
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { DnsRecordModel } from './Distribution.Api.Models.DnsRecord';
import { DnsResponseStatus } from 'enums/DnsResponseStatus';
import { Model, ModelProperty } from 'models/Model';


export class DnsRecordsResponseModel extends Model<DnsRecordsResponseModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'records', type: 'DnsRecordModel[]', languageString: 'dnsRecordsResponse.property.records', isHidden: true, isArray: true, isObject: true, new: () => { return new DnsRecordModel }, properties: () => { return DnsRecordModel.classProperties } },
		{ name: 'responseStatus', type: 'DnsResponseStatus', languageString: 'dnsRecordsResponse.property.responseStatus' }
	];
	[key: string]: any;
	
	public records: DnsRecordModel[];
	public responseStatus: DnsResponseStatus;
    
	constructor(){
		super();
		this.records = [];
		this.responseStatus = 0;
		
	}
	getProperties(){
		return DnsRecordsResponseModel.classProperties;
	}
}

